
import { computed, defineComponent, PropType, ref } from 'vue'
import { WPeriodontalReportCreation } from '@/widgets/WPeriodontalReportCreation'
import { EPeriodontalMapTable } from '@/entities/EPeriodontalMapTable'
import { EPeriodontalGraphic } from '@/entities/EPeriodontalGraphic'
import { PeriodontalReportType } from '@/shared/types'
import { useRoute } from 'vue-router'
import { useOrganizationModules } from '@/shared/composables'

export default defineComponent({
  name: 'PeriodontalMap',
  components: {
    WPeriodontalReportCreation,
    EPeriodontalMapTable,
    EPeriodontalGraphic,
  },

  props: {
    data: Object as PropType<PeriodontalReportType>,
  },

  setup() {
    const { organizationModules } = useOrganizationModules()
    const route = useRoute()

    const isCreationDialogVisible = ref(false)

    const isPreviewMode = computed(() => route.query['view-mode'] === '1')

    const handleOpenCreationDialog = () => {
      if (organizationModules.value.indexOf('periodontology') > -1) {
        isCreationDialogVisible.value = !isCreationDialogVisible.value
      }
    }

    return {
      isCreationDialogVisible,
      isPreviewMode,
      handleOpenCreationDialog,
      organizationModules,
    }
  },
})
